import { sendCommonInfoEvent, setRegisterEnd, setRegisterStart } from '../internal/commonMetric';
import { getWebInitTimestamp } from '../internal/util';
export const createScenario = () => {
    const getFirstScreenRequests = (slardarClient) => {
        var _a, _b;
        try {
            // eslint-disable-next-line @ttfe/@typescript-eslint/no-unnecessary-condition
            const { ignoreApiUrl = [], includeApiUrl = [] } = (_b = (_a = slardarClient === null || slardarClient === void 0 ? void 0 : slardarClient.getState) === null || _a === void 0 ? void 0 : _a.call(slardarClient)) !== null && _b !== void 0 ? _b : {};
            const timings = performance.getEntriesByType('resource').filter((x) => {
                const entry = x;
                if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
                    if (!ignoreApiUrl.length && !includeApiUrl.length) {
                        return true;
                    }
                    if (includeApiUrl.length) {
                        return includeApiUrl.some((url) => typeof url === 'string' ? entry.name.includes(url) : url.test(entry.name));
                    }
                    return !ignoreApiUrl.some((url) => typeof url === 'string' ? entry.name.includes(url) : url.test(entry.name));
                }
                return false;
            });
            const navStart = getWebInitTimestamp();
            return timings.map((x) => ({
                startTime: x.startTime + navStart,
                endTime: x.startTime + x.duration + navStart,
            }));
        }
        catch (e) {
            const timings = performance.getEntriesByType('resource').filter((x) => {
                const entry = x;
                if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
                    return true;
                }
                return false;
            });
            const navStart = getWebInitTimestamp();
            return timings.map((x) => ({
                startTime: x.startTime + navStart,
                endTime: x.startTime + x.duration + navStart,
            }));
        }
    };
    const scenario = (slardarClient) => {
        return {
            setRegisterStart,
            setRegisterEnd,
            preRegister: async () => {
                // do nothing
            },
            postRegister: () => {
                try {
                    const { isSpaRouteCheck } = slardarClient.getState();
                    if (!isSpaRouteCheck) {
                        sendCommonInfoEvent(slardarClient);
                    }
                }
                catch { }
            },
            getFirstScreenRequests: () => {
                return getFirstScreenRequests(slardarClient);
            },
            getState: () => ({
                type: 'webapp',
            }),
        };
    };
    return scenario;
};
function setTimestamp(name, key, timestamp) {
    try {
        if (!window.__VOM_GLOBAL_TIMING_STORE_KEY) {
            return;
        }
        window.__VOM_GLOBAL_TIMING_STORE_KEY[name] = {
            ...window.__VOM_GLOBAL_TIMING_STORE_KEY[name],
            [key]: timestamp,
        };
        return;
    }
    catch {
        console.error('set vmok timing failed');
    }
}
export const vmokRuntimePlugin = () => {
    // eslint-disable-next-line @ttfe/@typescript-eslint/no-unnecessary-condition
    if (typeof window !== 'undefined' && !window.__VOM_GLOBAL_TIMING_STORE_KEY) {
        window.__VOM_GLOBAL_TIMING_STORE_KEY = {};
    }
    return {
        name: 'mark-hook-timing-plugin',
        afterResolve(args) {
            const { remote } = args;
            setTimestamp(remote.name, 'afterResolve', Date.now());
            return args;
        },
        /**
         *  Triggered once a federated module is loaded, allowing access and modification to the exports of the loaded file.
         */
        onLoad(args) {
            const { remote } = args;
            setTimestamp(remote.name, 'onLoad', Date.now());
            return args;
        },
    };
};
//# sourceMappingURL=webapp.js.map